import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

export const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        opacity: 1,
      },
    },
    "&$disabled": {
      color: theme.palette.action.disabled,
      "& + $track": {
        backgroundColor: theme.palette.action.disabledBackground,
        borderColor: theme.palette.action.disabledBackground,
        opacity: 0.5,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    opacity: 1,
  },
  checked: {},
  disabled: {}, // ← Needed for the disabled class to apply
}))(Switch);

const SwitchOnOff = ({
  leftLabel,
  rightLabel,
  checked,
  setChecked,
  className,
  ...props
}) => {
  const handleTurnOn = () => setChecked(true);
  const handleTurnOff = () => setChecked(false);

  return (
    <Typography
      component="div"
      style={{ display: "inline-flex", alignItems: "center" }}
      className={className}
    >
      <Grid container alignItems="center" spacing={1} wrap="nowrap">
        {" "}
        {/* wrap="nowrap" to prevent wrapping */}
        <Grid item style={{ minWidth: "auto" }} onClick={handleTurnOff}>
          {leftLabel}
        </Grid>
        <Grid item>
          <AntSwitch
            {...props}
            name={`${leftLabel}_${rightLabel}`}
            checked={checked}
            onChange={() => setChecked(!checked)}
          />
        </Grid>
        <Grid item style={{ minWidth: "auto" }} onClick={handleTurnOn}>
          {rightLabel}
        </Grid>
      </Grid>
    </Typography>
  );
};

export default SwitchOnOff;
